import { Image } from '@tracklib/kit'
import cn from 'clsx'

import styles from './iconbox.css'

type IconBoxProps = {
  icon: JSX.Element
  image: number
  children: JSX.Element
  className?: string
}

const IconBox = ({ icon, image, children, className }: IconBoxProps): JSX.Element => (
  <div className={cn(styles.quote, className)}>
    <div className={styles.imageWrapper} datatesting="quote_image">
      <Image image={image} absolute className={styles.image} />
    </div>
    <div className={styles.body}>
      <div className={styles.cutout} />
      <span className={styles.sign}>{icon}</span>
      {children}
    </div>
  </div>
)

export default IconBox
